import React from "react";
import { Input, TextArea, GroupByPanelContent, FilterPanel } from "@aidkitorg/component-library";
import { GroupByConfig, ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useLocalizedStrings } from "../../../Localization";
import { useFieldOptions } from "../../hooks/useFieldOptions";
import { useSettingsFilterFields } from "../../Filters/hooks/useSettingsFilterFields";
import { useFieldValueSuggestions } from "../../shared/hooks/useFieldValueSuggestions";

export type SummaryTableFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  groupByConfig: GroupByConfig,
  onGroupByChange: (config: GroupByConfig) => void,

  filterConfig?: ReportFilterConfig,
  setFilterConfig: (val: ReportFilterConfig | undefined) => void,
}

export const SummaryTableFormFields: React.FC<SummaryTableFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  groupByConfig, onGroupByChange,
  filterConfig, setFilterConfig,
}) => {
  const L = useLocalizedStrings()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()
  const availableFieldsForFilters = useSettingsFilterFields();
  const { fetchSuggestions } = useFieldValueSuggestions();

  return <>
    <Input 
      required
      label="Table Title"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
    
    {/* What we're measuring */}
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.summary_table_measuring}
      </label>
      <div className="text-sm text-gray-600 bg-gray-50 p-3 rounded-md border">
        📊 <strong>{L.admin_panel.dashboards.applicant_count}</strong> - {L.admin_panel.dashboards.summary_table_measuring_desc}
      </div>
    </div>
    
    {/* Group By Columns */}
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.group_by_cols}
      </label>
      <p className="text-xs text-gray-500">
        {L.admin_panel.dashboards.group_by_cols_desc}
      </p>
      
      <GroupByPanelContent
        compact
        hideSortDirection
        value={groupByConfig}
        onChange={onGroupByChange}
        availableFields={fieldOptions.map(option => ({
          key: option.value,
          label: String(option.label),
          type: 'text' as const
        }))}
        className="border p-2"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {L.admin_panel.dashboards.filters_label}
      </label>
      <FilterPanel
        value={filterConfig}
        onChange={setFilterConfig}
        availableFields={availableFieldsForFilters}
        instanceId="summary-table-form-filters"
        fetchFieldValues={fetchSuggestions}
        inline
      />
    </div>

    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}